import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=c168fea6&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"
import style0 from "./badge.vue?vue&type=style&index=0&id=c168fea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168fea6",
  null
  
)

export default component.exports